export const TAGE = {
  monday: 0,
  tuesday: 1,
  wednesday: 2,
  thursday: 3,
  friday: 4,
  saturday: 5,
  sunday: 6,
} as const;

export type Tage = typeof TAGE;

export function getTageKeyByValue(
  value: Tage[keyof Tage],
): keyof Tage | undefined {
  return (Object.keys(TAGE) as Array<keyof Tage>).find(
    (key) => TAGE[key] === value,
  );
}

export const arbeitstage = {
  '1 Tag': '1 Tag',
  '2 Tage': '2 Tage',
  '3 Tage': '3 Tage',
  '4 Tage': '4 Tage',
  '5 Tage': '5 Tage',
  '6 Tage': '6 Tage',
  '7 Tage': '7 Tage',
  flexibel: 'flexibel',
} as const;

export type Arbeitstage = typeof arbeitstage;
